export default "__VITE_ASSET__E5LbVOyv__"